/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';

import MaterialTable, {MaterialTableProps} from 'material-table';
import TablePagination from '@material-ui/core/TablePagination';


const CustomMaterialTable = (
    props: MaterialTableProps<any>,
):JSX.Element => {
  const [t] = useTranslation();

  const getLocalization = () => ({
    body: {
      emptyDataSourceMessage: t('Sem dados para exibir'),
      deleteText: t('Tem certeza que deseja excluir esta linha?'),
      addTooltip: t('Adicionar'),
      deleteTooltip: t('Deletar'),
      editTooltip: t('Editar'),
      filterRow: {
        filterPlaceHolder: t('Filtrar'),
        filterTooltip: t('Filtrar'),
      },
      editRow: {
        deleteText: t('Tem certeza que deseja excluir?'),
        cancelTooltip: t('Cancelar'),
        saveTooltip: t('Salvar'),
      },
    },
    grouping: {
      placeholder: t('Arraste o título da coluna para agrupar as linhas'),
      groupedBy: t('Agrupar por:'),
    },
    header: {actions: t('Ações')},
    pagination: {
      labelDisplayedRows: `{from}-{to} ${t('de')} {count}`,
      labelRowsSelect: t('linhas'),
      labelRowsPerPage: t('Linhas por página:'),
      firstAriaLabel: t('Primeira página'),
      firstTooltip: t('Primeira página'),
      previousAriaLabel: t('Página anterior'),
      previousTooltip: t('Página anterior'),
      nextAriaLabel: t('Próxima página'),
      nextTooltip: t('Próxima página'),
      lastAriaLabel: t('Última página'),
      lastTooltip: t('Última página'),
    },
    toolbar: {
      addRemoveColumns: t('Adicionar ou remover colunas'),
      nRowsSelected: `{0} ${t('linhas(s) selecionadas')}`,
      showColumnsTitle: t('Mostrar colunas'),
      showColumnsAriaLabel: t('Mostrar colunas'),
      exportTitle: t('Exportar'),
      exportAriaLabel: t('Exportar'),
      exportName: t('Exportar como CSV'),
      exportCSVName: t('Exportar como CSV'),
      searchTooltip: t('Pesquisar'),
      searchPlaceholder: t('Busca'),
    },
  });

  const localization = getLocalization();
  const {pageSize = 100} = props.options || {};
  const [localPageSize, setLocalPageSize] = useState<number>(pageSize);

  useEffect(() => {
    if (pageSize) setLocalPageSize(pageSize);
  }, [pageSize]);

  return (
    <MaterialTable
      {...props}
      components={{
        Pagination: (paginationProps) => {
          const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
            // enable to set rows per page to match total count
            setLocalPageSize(parseInt(event.target.value));
            paginationProps.onChangeRowsPerPage(event);
          };

          return (
            <TablePagination
              {...paginationProps}
              rowsPerPage={localPageSize}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          );
        },
        ...props.components,
      }}
      localization={{...localization, ...props.localization}}
      options={{
        emptyRowsWhenPaging: false,
        padding: 'dense',
        pageSize: localPageSize,
        pageSizeOptions: [10, 25, 50, 100],
        ...props.options,
      }}
    />
  );
};

export default CustomMaterialTable;
